export const SCHEDULE_FILTER = {
  TODAY: 'TODAY',
  UPCOMING: 'UPCOMING',
};
